<template>
  <div class="">
    <ZnBreadcrumb>
      <div slot="rightbutton">
        <el-button type="primary"  @click="addAccount"
          >新增账号</el-button
        >
      </div>
    </ZnBreadcrumb>
    <div class="main-content">
      <div class="search-type">
        <ul class="clearfix">
          <li>
            <img src="../../assets/images/searchIcon.png" alt="" />
            <input
              type="text"
              placeholder="关键字搜索"
              v-model="searchData.accountName"
              @keyup.enter="initData('search')"
            />
           
            <el-button
          class="cursorPointer"
          @click="initData('search')"
        >  快速查询
        </el-button>


          </li>
        </ul>
      </div>
      <div class="goods-info">
        <el-table
          :data="userList"
          :header-cell-style="{
            background: '#F8FAFC',
            color: 'rgba(0, 0, 0, 0.85)',
            fontWeight: 700,
            height: '54px',
          }"
          border
          style="width: 85%"
        >
          <template slot="empty">
            <img src="../../assets/images/empty.png" class="empty" />
            <p>暂无操作记录</p>
          </template>
          <el-table-column prop="id" label="账号ID"> </el-table-column>
          <el-table-column prop="accountName" label="账号"> </el-table-column>
          <el-table-column prop="showPass" label="密码"> </el-table-column>
          <el-table-column prop="iccard" label="IC卡号"> </el-table-column>
          <el-table-column prop="nickName" label="真实姓名"> </el-table-column>
          <el-table-column prop="userRole" label="权限">
            <template slot-scope="scope">
              <span>{{scope.row.userRole==1?'管理员':'普通用户' }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="gmtCreate" label="注册时间"> </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span
                :class="scope.row.checkEnabled == '正常' ? 'nomal' : 'disabled'"
                >{{ scope.row.checkEnabled }}</span
              >
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
          
                <img @click="editAccount(scope.row)" src="../../assets/private/update.png" title="编辑" style="height: 25px;width: 25px;float: left;">
               
 <img @click="handelAccount(scope.row, false)"   v-if="scope.row.checkEnabled == '正常'" src="../../assets/private/jinyong.png" title="禁用" style="height: 25px;width: 25px;float: left;">
               
 
               <img  @click="handelAccount(scope.row, true)"   v-if="scope.row.checkEnabled == '已禁用'" src="../../assets/private/qiyong.png" title="启用" style="height: 25px;width: 25px;float: left;">
              
              <img   @click="resultPassword(scope.row)"   src="../../assets/private/chongzhi.png" title="重置密码" style="height: 25px;width: 25px;float: left;">
              <img   @click="removeMember(scope.row)"   src="../../assets/private/移除.png" title="删除账号" style="height: 25px;width: 25px;float: left;">


                         
 
               
            </template>
          </el-table-column>
        </el-table>
        <div style="width: 82%">
          <Pagination :dataTotal="pagedata.total" :totalpage='pagedata.totalpage' :pagesize='searchData.pageSize' @changePage='changePage'></Pagination>
        </div>

      </div>
      <!-- 编辑账号弹框 -->
      <el-dialog
        :title="dialogType == 'add' ? '新增账号' : '编辑账号'"
        :visible.sync="dialogAccount"
        class="placeDia"
        width="460px"
      >
        <ul>
          <li>
            <label>真实姓名<span class="requiedText">*</span></label>
            <input
              type="text"
              v-model="accountEdit.nickName"
              placeholder="请输入真实姓名"
            />
          </li>
          <li>
            <label>登录帐号<span class="requiedText">*</span></label>
            <input
              type="text"
              v-model="accountEdit.accountName"
              placeholder="请输入登录帐号"
              :disabled = "dialogType !== 'add'"
            />
          </li>
           <li>
            <label>邮箱地址<span class="requiedText">*</span></label>
            <input
              type="text"
              v-model="accountEdit.email"
              placeholder="请输入邮箱地址"
            />
          </li>
          <li>
            <label>手机号<span class="requiedText">*</span></label>
            <input
                type="text"
                v-model="accountEdit.cellphone"
                placeholder="请输入手机号"
            />
          </li>
          <li>
            <label>课题组<span class="requiedText">*</span></label>
              <input
              disabled 
              type="text"
              v-model="currentUserInfo.taskName"
            /> 
            <!-- 编辑账号弹框<el-select v-model="currentUserInfo.taskName" filterable @change='settaskName' class="right" placeholder="请选择">
              <el-option
                v-for="item in Research"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select> -->
          </li>
          <li>
            <label>身份<span class="requiedText">*</span></label>
            <el-select v-model="accountEdit.userRole" class="right" placeholder="请选择" >
              <el-option   @click.native="isAdmin(item)" 
                v-for="item in identityArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </li>
<!--          <li>-->
<!--            <label>权限设置<span class="requiedText">*</span></label>-->
<!--              <el-cascader-->
<!--              class="right"-->
<!--              :options="navMenuData"-->
<!--              :props="{-->
<!--                multiple:true-->
<!--              }"-->
<!--              v-model="accountEdit.userPermissions"-->
<!--              size="medium"-->
<!--              collapse-tags-->
<!--              clearable></el-cascader>-->
<!--          </li>-->
          <li class="addtoast" v-if="dialogType == 'add'">
            <label>登录密码</label>
            <span><span>*</span>初始密码统一为：123456</span>
          </li>
          <li>
            <label>IC卡号</label>
            <input
              type="text"
              v-model="accountEdit.iccard"
              placeholder="请输入IC卡号"
            />
          </li>
        </ul>
       
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogAccount = false">取 消</el-button>
          <el-button type="primary" @click="confirmBorrow()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      accountEdit: {
        schoolName:'',
        accountName:'',
        userRole:'',
        userPermissions:[[100],[102],[103,104],[103,105],[103,106],[107],[116,117],[116,118],[116,123],[119,120],[119,121],[119,122]],
        email:'',
        cellphone:'',
        taskId:'',
      },
      dialogAccount: false,
      searchData: {
        accountName: "",
        pageNum: 1,
        pageSize: 10,
      },
      orderStatus: "",
      auditStatus: "",
      alias: "",
      userList: [],
      dialogType: "",
      Research: [],
      identityArr:[
        {
          value: 1,
          label: "管理员",
        },{
          value: 2,
          label: "普通员工",
        }
      ],
      authorityArr:[
        {
          value: 1,
          label: "权限1",
        },
        {
          value: 2,
          label: "权限2",
        }
      ],
      navMenuData: [
        {
          value: 100,
          label: "首页搜索",
        },
        {
          value: 125,
          label: "库存管理",
          children: [
            {
              value: 101,
              label: "柜机管理",
            },
            {
              value: 102,
              label: "试剂管理",
            },
          ],
        },
        {
          value: 103,
          label: "我的选购",
          children: [
            {
              value: 104,
              label: "购物车",
            },
            {
              value: 105,
              label: "我的订单",
            },
            {
              value: 106,
              label: "我的额度",
            },
          ],
        },
        {
          value: 126,
          label: "PDA盘点",
        },
        {
          value: 127,
          label: "系统日志",
          children: [
            {
              value: 107,
              label: "柜机日志",
            },
            {
              value: 128,
              label: "搜索日志",
            },
          ],
        },
        {
          value: 116,
          label: "我的操作",
          children: [
            {
              value: 117,
              label: "领用筐",
            },
            {
              value: 118,
              label: "组内转用",
            },
            {
              value: 124,
              label: "跨组借用",
            },
            {
              value: 123,
              label: "我的领用",
            },
          ],
        },
        {
          value: 108,
          label: "管理员权限",
          children: [
            {
              value: 109,
              label: "账号管理",
            },
            {
              value: 110,
              label: "额度分配",
            },
            {
              value: 111,
              label: "试剂公开",
            },
            {
              value: 112,
              label: "订单审核",
            },
            {
              value: 115,
              label: "采购统计",
            },
            {
              value: 114,
              label: "领用统计",
            },

          ],
        },
        {
          value: 119,
          label: "个人中心",
          children: [
            {
              value: 120,
              label: "我的资料",
            },
            {
              value: 121,
              label: "我的地址",
            },
            {
              value: 122,
              label: "退出账号",
            },

          ],
        },

      ],
      locationtype:'',
      pagedata:{
        total:1,
        totalpage:1
      },
      currentUserInfo:{}
    };
  },
  created() {
    const userInfo = localStorage.getItem('userInfo')
    this.currentUserInfo = JSON.parse(userInfo)
    this.initData();
    this.getSchoolTask()
  },
  methods: {
    isAdmin(item){
		var accountName1=this.accountEdit.accountName;
		var nickName1=this.accountEdit.nickName;
		
		var email1=this.accountEdit.email;
		var cellphone1=this.accountEdit.cellphone;
		var taskName1=this.accountEdit.taskName;
		var iccard1=this.accountEdit.iccard;
		var userRole1=this.accountEdit.userRole;
		var id1=this.accountEdit.id;
		debugger;
      if(item.value=='1'){
        //alert("管理员");
        this.accountEdit = {userPermissions:[[100], [125, 101], [125, 102], [103, 104], [103, 105], [103, 106], [126], [127, 107], [127, 128], [116, 117], [116, 118], [116, 124], [116, 123], [108, 109], [108, 110], [108, 111], [108, 112], [108, 115], [108, 114], [119, 120], [119, 121], [119, 122]]}

      }else{
        // alert("普通员工");
        this.accountEdit = {userPermissions:[[100], [125, 101], [125, 102], [103, 104], [103, 105], [103, 106], [126], [127, 107], [127, 128], [116, 117], [116, 118], [116, 124], [116, 123], [119, 120], [119, 121], [119, 122]]}

      }
			this.accountEdit.accountName=accountName1;
			this.accountEdit.nickName=nickName1;
			this.accountEdit.email=email1;
			this.accountEdit.cellphone=cellphone1;
			this.accountEdit.taskName=taskName1;
			this.accountEdit.iccard=iccard1;
			this.accountEdit.userRole=userRole1;
			this.accountEdit.id=id1;
       
    },
    changePage(data){
      this.searchData.pageNum = data
      this.initData()
    },
    //操作按钮
    handelAccount(row, type) {
      let id = row.id;
      let status = type;
      console.log(status);
      this.$apiFetch
        .get(`/lockerUser/checkStatus?id=${id}&status=${status}`)
        .then((res) => {
          console.log(res);
          this.initData();
        });
    },
    //操作按钮
    removeMember(row) {
      let id = row.id;

      this.$confirm("您确认删除该账号吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.$apiFetch
            .get(`/lockerUser/removeMember?id=${id}`)
            .then((res) => {
              this.initData();
            });
          }).catch(() => {
          });
    },
    //编辑账号
    editAccount(row) {
      let id = row.id;
      console.log(id);
      this.dialogType = "edit";
      this.accountEdit = {
        id,
        schoolName:row.schoolName,
        accountName:row.accountName,
        userRole:row.userRole,
        userPermissions:row.userPermissions,
        taskId:row.taskId,
        schoolId:row.schoolId,//学校id
        taskName:row.taskName, //课题组名称
        nickName:row.nickName,//昵称？？
        email:row.email,//邮箱
        cellphone:row.cellphone,//手机
        iccard:row.iccard//IC卡号
      }
      this.dialogAccount = true;
    },
    addAccount() {
      this.dialogType = "add";
      //this.accountEdit = {userPermissions:[[100],[110,118],[110,111],[110,112],[110,113],[110,114]]}

this.accountEdit = {userPermissions:[[100],[102],[103,104],[103,105],[103,106],[107],[116,117],[116,118],[116,123],[119,120],[119,121],[119,122]]}
      // ,
      this.dialogAccount = true;
      //默认赋值
    },
    // 重置密码
    resultPassword(row) {
      let id = row.id;
      this.$apiFetch.get(`/lockerUser/resetPassword?id=${id}`).then(() => {
        this.$message({
            showClose: true,
            message: '重置成功',
            type: 'success'
        });
        this.initData()
      });
    },
    initData() {
      // if(type == 'search' && !this.searchData.accountName){
      //   this.$message({
      //     showClose: true,
      //     message: '请输入搜索关键词',
      //     type: 'warning'
      //   });
      // }
      let params = this.searchData;
      this.$apiFetch.get(`/lockerUser/queryUserList`, params).then((res) => {
        res.data.list.map((item) => {
          item.showPass = item.updatePwd ? '******' : item.supplierPwd;
          if (item.checkEnabled) {
            item.checkEnabled = "正常";
          } else {
            item.checkEnabled = "已禁用";
          }
        });
      this.pagedata={
        total:res.data.total,
        totalpage:res.data.pages
      }
        this.userList = res.data.list;

      });
    },
    getSchoolTask(){
      // 获取课题组
      this.$apiFetch.get(`/lockerSchoolTask/list`).then((res) => {
        this.Research = res.data.map((item)=>{
          return {value:item.id,label:item.taskName}
        }) 
      });
    },
    settaskName(e){
      console.log('set',e)
      let obj = this.Research.find((x) =>{return x.value === e })
      this.accountEdit.taskName = obj.label
       this.currentUserInfo.taskId = obj.value
    },
    confirmBorrow(){
      this.accountEdit.taskId =  this.currentUserInfo.taskId
      this.accountEdit.taskName = this.currentUserInfo.taskName
      // 确定新增或修改 add 新增 edit 修改(/lockerUser/updateUser)
      console.log('accont',this.accountEdit)
      if(!this.accountEdit.userPermissions || this.accountEdit.userPermissions.length<1){
        this.$message.error('请选择权限~')
        return;
      }
      let params =Object.assign({},this.accountEdit) ;
      console.log('params',params)
      const {accountName,userRole,nickName,taskId,userPermissions,email,cellphone} = params
      if(!accountName||!userRole||!nickName||!taskId||userPermissions.length<1||!email||!cellphone){
        this.$message.error('请填写完整后提交')
        return;
      }
      // if (!this.isEmail(this.accountEdit.email)){
      //   return this.$message.error("请填写正确的邮箱地址");
      // }
      if(this.dialogType === 'add'){
        // params.schoolId
        // params.nickName
        this.$apiFetch.post(`/lockerUser/insertUser`,params).then((res) => {
          if(!res.data.code){
            this.$message({
                showClose: true,
                message: '新增成功',
                type: 'success'
            });
            // setTimeout(()=>{
            this.dialogAccount = false;
            this.initData()
            // },1000)
          }else{
            this.$message.error(res.data.description)
          }
        });
      }else{
        this.$apiFetch.post(`/lockerUser/updateUser`,params).then((res) => {
          if(!res.data.code){
            this.$message({
                showClose: true,
                message: '修改成功',
                type: 'success'
            });
            this.dialogAccount = false;
            this.initData()
          }else{
            this.$message.error(res.data.description)
          }
        });
      }
      
    },

    isEmail(val){
      const reg = /^(\w)+(\.\w+)*@(\w)+((\.\w{2,3}){1,3})$/;
      return reg.test(val)
    },
  },
};
</script>
<style lang="less" scoped>
.main {
  background-color: #ffffff;
}
.placeDia {
  ul {
    li {
      padding-top: 20px;
      display: flex;
      label {
        display: block;
        color: #666666;
        font-size: 14px;
        width: 25%;
        line-height: 41px;
      }
      input {
        border-bottom: 1px solid #cccccc;
        font-size: 14px;
        line-height: 40px;
        width: 100%;
        color: #333333;
      }

      input::-webkit-input-placeholder { 
      /* WebKit browsers */ 
      color: #ccc; 
      } 
      input:-moz-placeholder { 
      /* Mozilla Firefox 4 to 18 */ 
      color: #ccc; 
      } 
      input::-moz-placeholder { 
      /* Mozilla Firefox 19+ */ 
      color: #ccc; 
      } 
      input:-ms-input-placeholder { 
      /* Internet Explorer 10+ */ 
      color: #ccc; 
      }
    }
    li:first-child {
      padding-top: 0;
    }
    
  }
  .locking {
    width: 100%;
    height: 36px;
    text-align: center;
    line-height: 36px;
    color: #478aff;
    border-radius: 4px;
    border: 1px solid #478aff;
    background-color: #ffffff;
    margin-top: 25px;
  }
  span.tips {
    color: #ff4d4f;
    padding-top: 6px;
    text-align: center;
    display: block;
  }
}
/deep/ .el-table {
  margin-top: 20px;
  border-radius: 4px 4px 0 0;
  img.empty {
    width: 196px;
    margin-top: 38px;
  }
  button.forbid {
    color: #ff4d4f;
  }
  span.nomal {
    padding-left: 10px;
  }
  span.disabled {
    padding-left: 10px;
  }
  .nomal::before {
    width: 5px;
    height: 5px;
    background: #52c41a;
    border-radius: 50%;
    content: "";
    position: absolute;
    left: 10px;
    top: 28px;
  }

  span.disabled::before {
    background-color: #ff4d4f;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    content: "";
    position: absolute;
    left: 10px;
    top: 30px;
  }
}
.search-type {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid #eef2f8;
  ul {
    li {
      float: left;
      position: relative;
      img {
        width: 14px;
        display: block;
        position: absolute;
        top: 11px;
        left: 9px;
      }
      input {
        width: 380px;
        height: 36px;
        border-radius: 4px;
        border: 1px solid #cccccc;
        padding-left: 28px;
      }
      button {
        width: 98px;
        height: 36px;
        background: #478aff;
        border-radius: 4px;
        font-size: 12px;
        color: #ffffff;
        margin-left: 12px;
      }
    }
  }
}
.goods-info {
  padding: 20px;
  background-color: #ffffff;
}
/deep/.right {
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  border-bottom:1px solid#CCCCCC;
  display: flex;
  align-items: center;
  .el-input--suffix{
    height: 100%;
  }
  input {
    // height: 20px;
    background-color: #fff;
    border: none;
    padding: 0;
  }

  .el-input__icon {
    line-height: 20px;
  }

  &::placeholder {
    color: #ccc;
  }
}
.requiedText{
  color: red;
}

</style>
